import { Controller } from 'stimulus';
import loadDatepicker from '@/helpers/loadDatepicker';

class Datepicker extends Controller {
  connect() {
    loadDatepicker().then(this.createDatePicker.bind(this));
  }

  createDatePicker() {
    $(this.element).datepicker({
      ...this.getDefaultOptions(),
      ...this.getOptionsFromElement(),
    });
  }

  getDefaultOptions() {
    return {
      language: 'nl',
      datesDisabled: this.getOptionOrDefault('disabled-dates', []),
      daysOfWeekDisabled: this.getOptionOrDefault('disabled-days-of-week', []),
      defaultViewDate: this.getOptionOrDefault('default-view-date', 'today'),
      startView: this.getOptionOrDefault('start-view', 0),
      startDate: this.getOptionOrDefault('start-date', -Infinity),
      format: 'dd.mm.yyyy',
    };
  }

  getOptionOrDefault(key, defaultValue) {
    return this.data.has(key) ? this.data.get(key) : defaultValue;
  }

  getOptionsFromElement() {
    const options = this.element.dataset;
    const config = {};

    if (typeof options === 'undefined') {
      return config;
    }

    Object.keys(options).forEach((option) => {
      const regex = new RegExp('^datepicker', 'g');

      if (!regex.test(option)) {
        return;
      }

      let value = options[option];
      let transformedOption = option.replace('datepicker', '');

      transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

      if (value === 'true') {
        value = true;
      } else if (value === 'false') {
        value = false;
      }

      config[transformedOption] = transformedOption === 'breakpoints'
        ? JSON.parse(value)
        : value;
    });

    return config;
  }
}

export default Datepicker;
